// Microsoft Store build detection. Store policy 10.1.5 forbids promoting software acquired outside the Store, so the
// installed-from-Store PWA hides every connector download link. Trips on: the ?source=msstore start_url PWABuilder sets,
// the Store launch referrer, OR simply running as an installed app (standalone window) on Windows — which is exactly how
// a certification reviewer runs it, whatever start URL the package ended up with. Remembered for later navigations.
const KEY = "xp.msstore";
let cached = null;
const installedOnWindows = () => {
  const ua = navigator.userAgent || "";
  const standalone = ["standalone", "window-controls-overlay", "minimal-ui", "fullscreen"].some((m) => window.matchMedia?.(`(display-mode: ${m})`).matches);
  return /Windows/i.test(ua) && (standalone || window.navigator.standalone === true);
};
export const isStoreBuild = () => {
  if (cached !== null) return cached;
  try {
    const q = new URLSearchParams(window.location.search).get("source");
    const hit = q === "msstore" || (document.referrer || "").startsWith("app-info://platform/microsoft-store") || installedOnWindows();
    if (hit) localStorage.setItem(KEY, "1");
    cached = hit || localStorage.getItem(KEY) === "1";
  } catch { cached = false; }
  return cached;
};
export const STORE_CONNECTOR_NOTE = "The plotter connector is built into this app and starts with Windows — plug the plotter into this computer with a USB cable and it appears in the list above.";
